module.exports = __webpack_public_path__ + "static/img/google-scholar-icon.a5e6a32.svg";


//////////////////
// WEBPACK FOOTER
// ./static/source-logo/google-scholar-icon.svg
// module id = BIx0
// module chunks = 1